import ActionCable from 'actioncable'

const cable = ActionCable.createConsumer(process.env.VUE_APP_ACTION_CABLE_ENDPOINT)

export { cable }
